var Gender = {
  FEMALE: 0,
  MALE: 1
}

export { Gender }
